const isUrlInternal = url => {
    if (!url) return false;
    if (url === '/') return true;

    return (url[0] === '/')
        // url doesn't start with "//" or "/\"
        ? url[1] !== '/' && url[1] !== '\\'
        : false;
};

const redirectToUrl = url => {
    // Redirect to internal URL
    if (isUrlInternal(url)) {
        window.location.href = url;

    // Redirect to homepage for external URLs
    } else {
        window.location.href = '/';
    }
};

export default {
    isUrlInternal,
    redirectToUrl
};
